const LightVariants = {
	B1Light: { fontSize: 50, lineHeight: 64, fontWeight: 200 },
	B2Light: { fontSize: 36, lineHeight: 48, fontWeight: 200 },
	B3Light: { fontSize: 30, lineHeight: 40, fontWeight: 200 },
	B4Light: { fontSize: 25, lineHeight: 32, fontWeight: 200 },
	B5Light: { fontSize: 17, lineHeight: 24, fontWeight: 200 },
	B6Light: { fontSize: 14, lineHeight: 20, fontWeight: 200 },
};

const MediumVariants = {
	B1Medium: { fontSize: 50, lineHeight: 64, fontWeight: 400 },
	B2Medium: { fontSize: 36, lineHeight: 48, fontWeight: 400 },
	B3Medium: { fontSize: 30, lineHeight: 40, fontWeight: 400 },
	B4Medium: { fontSize: 25, lineHeight: 32, fontWeight: 400 },
	B5Medium: { fontSize: 17, lineHeight: 24, fontWeight: 400 },
	B6Medium: { fontSize: 14, lineHeight: 20, fontWeight: 400 },
};

const BoldVariants = {
	B1Bold: { fontSize: 50, lineHeight: 64, fontWeight: 600 },
	B2Bold: { fontSize: 36, lineHeight: 48, fontWeight: 600 },
	B3Bold: { fontSize: 30, lineHeight: 40, fontWeight: 600 },
	B4Bold: { fontSize: 25, lineHeight: 32, fontWeight: 600 },
	B5Bold: { fontSize: 17, lineHeight: 24, fontWeight: 600 },
	B6Bold: { fontSize: 14, lineHeight: 20, fontWeight: 600 },
};

const HeadingVariants = {
	H1Bold: { fontSize: 50, lineHeight: 64, fontWeight: 800 },
	H2Bold: { fontSize: 36, lineHeight: 48, fontWeight: 800 },
	H3Bold: { fontSize: 30, lineHeight: 40, fontWeight: 800 },
	H4Bold: { fontSize: 25, lineHeight: 32, fontWeight: 800 },
	H5Bold: { fontSize: 17, lineHeight: 24, fontWeight: 800 },
	H6Bold: { fontSize: 14, lineHeight: 20, fontWeight: 800 },
};

const defaultTextVariant = MediumVariants.B6Medium;
const smallTextVariant = MediumVariants.B6Medium;
// @davidstellini 22.09.2023: CAP-198: Agreed with vinod we shouldn't be going
// smaller than 14, but if it's too much to fix we can add a new variant
const largeTextVariant = MediumVariants.B5Medium;

export const FontVariantStyles = {
	...LightVariants,
	...MediumVariants,
	...BoldVariants,
	...HeadingVariants,
	sm: smallTextVariant,
	md: defaultTextVariant,
	lg: largeTextVariant,
};
